<template>
  <div :class="color + ' chip'">
    {{ text }}
    <i class="fa-solid fa-xmark cursor-pointer" @click="emitRemove" v-if="clearable"></i>
  </div>
</template>

<script setup>
const emit = defineEmits(['remove'])

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
  clearable: {
    type: Boolean,
    default: false,
  }
})

const emitRemove = () => {
  emit('remove')
}
</script>

<style>
.chip {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 16px;
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
}

.icon {
  cursor: pointer;
}
</style>
